import { relatorioDeHistoricoSenado } from "@/reports/pdf/patrimonio/itembempermanente/relatoriohistoricosenadoibp/index.js";

export function geradorDePdf(type, ibp, historico,  title) {
  switch (type) {
    case "rSIBP":
      relatorioDeHistoricoSenado(ibp, historico, title);
      break;
  }
}
